import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { useFormik } from "formik";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import DataTable from "react-data-table-component";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import * as Yup from "yup";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import { CreateNotes, DeleteNotes, ListNotesCancelToken } from "../../../services/ProjectCenterServices";
import { TABLE_ROWS_PER_PAGE } from "../../../utils/Constants";
import { formatQuestion } from "../../../utils/FormatQuestion";
import { handleTableScroll } from "../../../utils/commonFunction";
import PermissionsGate from "../../../utils/permissionGate";
import HtmlInputEditor from "../../common/HtmlInputEditor";
import Str from "../../common/Str";

const PCProjectNotes = () => {
  const { id, type, tab } = useParams();
  const [search1, setSearch1] = useState("");
  const [notes, setNotes] = useState();
  const [loadNotes, setLoadNotes] = useState(true);
  const [dummy, setDummy] = useState(false);
  const [disabledNotes, setDisabledNotes] = useState(false);
  const [projectNotes, setProjectNotes] = useState("")
  const [showNotesPopup, setShowNotesPopup] = useState(false);
  const [modalIcon, setModalIcon] = useState(false)

  useEffect(() => {
    handleTableScroll()
  }, [loadNotes])

  useEffect(() => {
    
    const cancelTokenSources = [];

    const listofnotes = async () => {
      setLoadNotes(true);
  
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {
        const res = await ListNotesCancelToken({ PId: id }, source.token);
        if (res.status === 200) {
          setNotes(res.data.data);
          setLoadNotes(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setLoadNotes(false);
        }
      }
    };
 
    listofnotes();
    
    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [dummy, type]);

  usePermissionGuardRedirect(['mtview']);

  const resetFilter1 = () => {
    setSearch1("");
  };


  const dataToRender = () => {
    let updatedData = [];
    let allData = notes;
    if (search1.length) {
      let tempId = allData.filter((item) => {
        let includes = item.note
          .toString()
          .toLowerCase()
          .includes(search1.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempdata = [...tempId];
      let unique = [...new Set(tempdata)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (search1.length) {
      return updatedData;
    } else {
      return notes;
    }
  };

  const notesSort = (a, b) => {
    return a && a.toString().toLowerCase() > b && b.toString().toLowerCase()
      ? 1
      : -1;
  };


  const handleSearchFilter1 = (e) => {
    const value = e.target.value;
    setSearch1(value);
  };

  const exportData = (fileType, fileName) => {
    let data, header;

    data = dataToRender();
    header = ["note"];
    data = data.map((row) => ({
      ...row,
      // ID: row.id ? row.id : "-",
      note: row.note ? formatQuestion(row.note).replaceAll("&nbsp;"," ") : "-",
    }));
    // }

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

      const blobURL = window.URL.createObjectURL(blob);

      // Create new tag for download file
      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.dataset.downloadurl = [
        "text/csv",
        anchor.download,
        anchor.href,
      ].join(":");
      anchor.click();

      // Remove URL.createObjectURL. The browser should not save the reference to the file.
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        URL.revokeObjectURL(blobURL);
      }, 1000);
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.forEach((col, index) => {
          obj[col] = row[col];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
      XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
      XLSX.writeFile(wb, `${fileName}.xlsx`);
      // Returning false as downloading of file is already taken care of
      return false;
    }
    if (fileType === "pdf") {
      let compatibleData;
      compatibleData = data.map((row) => {
        return [row["note"]];
      });
      //   }
      const doc = new JsPDF();
      doc.autoTable({
        head: [header],
        body: compatibleData,
        styles: {
          minCellHeight: 10,
          minCellWidth: 5,
          halign: "left",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);

      return false;
    }
  };


  const columns = useMemo(() => [
    {
      name: "Note",
      selector: "note",
      sortable: true,
      sortFunction: notesSort,
      wrap: true,
      cell: (row) => (
        <PermissionsGate scopes={["projectcenterprojectsview"]} RenderError={() => (
          <span className="feature-name"> <span className="textLimit100">{formatQuestion(row.note).replaceAll("&nbsp;"," ")}</span> </span>
        )}>
        <span className="as-text-blue curser feature-name"
        title={formatQuestion(row.note).replaceAll("&nbsp;"," ")} onClick={async () => {
          $("#add-note").modal("show")
          await formikX.setFieldValue("name", row.note)
          await formikX.setFieldValue("id", row.id)
          setProjectNotes(row.note)
          setModalIcon(true)
          setShowNotesPopup(true)
        }}>
          <span title={formatQuestion(row.note).replaceAll("&nbsp;"," ")} className="textLimit100">{formatQuestion(row.note).replaceAll("&nbsp;"," ")}</span>
        </span>
        </PermissionsGate>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="assessment-08 module-Note">
          <div className="as-buttons">
          <PermissionsGate errorProps={{ disabled: true}} scopes={["projectcenterprojectsview"]}>
            <button
              title="Open"
              className="btn btn-primary rounded-circle"
              onClick={async () => {
                $("#add-note").modal("show");
                await formikX.setFieldValue("name", row.note)
                await formikX.setFieldValue("id", row.id)
                setProjectNotes(row.note)
                setModalIcon(true)
                setShowNotesPopup(true)
              }}
            >
              <i className="fal fa-folder-open"></i>
            </button>
          </PermissionsGate>
          <PermissionsGate scopes={["projectcenterprojectsedit"]} errorProps={{ disabled: true }}>
            <button
              title="Delete"
              className="btn btn-danger rounded-circle"
              onClick={() => handleDeleteNote(row.module_id, row.id)}
            >
              <i className="fal fa-trash-alt"></i>
            </button>
          </PermissionsGate>
          </div>
        </div>
      ),
    },
  ]);

  const handleDeleteNote = (ID, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        
          DeleteNotes({ MId: ID, id: id })
            .then((res) => {
              Swal.fire("Deleted!", "Note has been deleted.", "success");
              setDummy(!dummy);
            })
            .catch((error) => console.log(error));
        

        // listofnotes();
      }
    });
  };

  const formikX = useFormik({
    initialValues: { name: "", id: false },
    validationSchema: Yup.object({
      name: Yup.string()
      .test("required", "Note is required", (value) => {
          if ((formatQuestion(projectNotes).replaceAll("&nbsp;", " ")).trim() == "" && !projectNotes.includes("<img")) {
              return false
          }
          if (!projectNotes) {
              return false
          }
          return true;
      })
      .trim(),
    }),
    onSubmit: (values) => {
      setDisabledNotes(true);
     
      CreateNotes({ ...values, PId: id, id: values.id, name:projectNotes })
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `${values.id ? "Updated" : "Added"} Successfully`,
          });
          setDisabledNotes(false);
          setLoadNotes(false);
          setDummy(!dummy);
          formikX.resetForm();
          $("#add-note").modal("hide");
          setShowNotesPopup(false)
        })
        .catch((err) => {
          setShowNotesPopup(false)
          console.log(err)
        });
      
    },
  });



  return (
    <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
      <div className="custom-table-div filter-search-icon card card-table-custom">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                      id="assessment-table-main_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        <input
                          type="search"
                          className=""
                          placeholder="Search"
                          aria-controls="assessment-table-main"
                          onChange={handleSearchFilter1}
                          value={search1}
                        />
                      </label>
                      <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                          <i className="fal fa-filter"></i>
                        </button>
                      </div>
                  </div>
                 
                </div>
              </div>
              <div className="filter-button-group">
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      onClick={() => resetFilter1()}
                      title="Reset"
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("xlsx", "Note", "Note");
                      }}
                      title="Export spreadsheet"
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("csv", "Note", "Note");
                      }}
                      title="Export CSV"
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("pdf", "Note", "Note");
                      }}
                      title="Export PDF"
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div className="search-filter-div-right">
                <div className=" filter-search-bar-blk"> 
                  <div className="add-ticket-blk button-reset dropdown-comman">
                  <PermissionsGate RenderError={() => (
                      <button className="btn btn-primary" title="Create New" disabled>Create New
                      </button>
                    )} scopes={["mtadd"]}>
                    <button
                      className="btn btn-primary"
                      data-toggle="modal"
                      data-target="#add-note"
                      title="Create New"
                      onClick={() => {
                        formikX.setFieldValue("name", "")
                        formikX.setFieldValue("id", false)
                        setProjectNotes("")
                        setShowNotesPopup(true);
                        setModalIcon(false)
                      }}
                    >
                      <i className="fal fa-plus"></i>Create New
                    </button>
                  </PermissionsGate>
                  </div>
                </div>
            </div>
        </div>
        <DataTable
          data={dataToRender()}
          columns={columns}
          pagination={true}
          progressComponent={<SkeletonTicketList />}
          progressPending={loadNotes}
          noDataComponent={Str.noRecord}
          defaultSortAsc={true}
          defaultSortField={"note"}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />
      </div>
      {showNotesPopup && <div
        className="Note-add-modal modal fade show"
        style={{ display: "block" }}
        id="add-note"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div className="modal-content modal-border-update">
            <form onSubmit={formikX.handleSubmit}>
              <div className="modal-body p-0">
                <div className="modal-header modal-header-custom">
                  <h5 className="modal-title">
                  {modalIcon ? <><i className="fal fa-folder-open"></i> Edit</> : <><i className="fal fa-plus"></i> Add</>} Note
                  </h5>
                  <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    $("#add-note").modal("hide");
                    formikX.setFieldValue("name", "")
                    setShowNotesPopup(false)
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div className="t p-30px">
                  <div className="Note-add-modal-content">
                    <div className="row center-label">
                      <div className="col-12">
                        <label>Note *</label>
                        <HtmlInputEditor
                          editorState={projectNotes}
                          setEditorState={setProjectNotes}
                          isCKEditor={true}
                          hideSign={true}
                          isInvalid={formikX.errors.name && formikX.touched.name}
                        />
                        {/* <input
                          type="text"
                          className={
                            "form-control" +
                            (formikX.errors.name && formikX.touched.name
                              ? " is-invalid"
                              : "")
                          }
                          placeholder="Enter Note"
                          title="Enter Note"
                          name="name"
                          value={formikX.values.name}
                          onChange={formikX.handleChange}
                          onBlur={formikX.handleBlur}
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div className="form-group form-group-save-cancel mt-3">
                    <button
                      className="btn btn-primary"
                      title="Save"
                      onClick={formikX.handleSubmit}
                      disabled={disabledNotes}
                    >
                      {disabledNotes ? (
                        <i className="fas fa-cog fa-spin"></i>
                      ) : (
                        <i className="fal fa-save"></i>
                      )}{" "}
                      Save
                    </button>
                    <button
                      className="btn btn-close btn-danger"
                      type="button"
                      title="Cancel"
                      onClick={() => {
                        $("#add-note").modal("hide");
                        formikX.setFieldValue("name", "")
                        setShowNotesPopup(false)
                      }}
                    >
                      <i className="fal fa-times"></i>Cancel
                    </button>
                    {formikX.touched.name && formikX.errors.name ? (
                      <div className="invalid-feedback d-block">
                        {formikX.errors.name}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>}
    </div>
  );
};

export default PCProjectNotes;
